function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".a{fill:#b1b7d8;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  id: "Icon",
  className: "a",
  d: "M359.727,911a2.6,2.6,0,0,1-1.842-.829l-3.978-4.223h-4.25a7.729,7.729,0,0,1-5.415-2.157,7.424,7.424,0,0,1,0-10.634A7.728,7.728,0,0,1,349.657,891h4.661a7.532,7.532,0,0,1,5.426,2.337,7.857,7.857,0,0,1,2.256,5.5v9.9A2.274,2.274,0,0,1,359.727,911Zm-10.07-18.008a5.484,5.484,0,1,0,0,10.963h5.078c.09.13.159.231.217.318A17.964,17.964,0,0,0,357.2,906.8c.535.565,1.217,1.288,2.1,2.223a.4.4,0,0,0,.29.123.418.418,0,0,0,.285-.114.407.407,0,0,0,.126-.3v-9.9a5.637,5.637,0,0,0-1.744-4.035,5.9,5.9,0,0,0-4.084-1.7l-.172-.1Z",
  transform: "translate(-342 -891)"
});

var SvgFaq = function SvgFaq(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFaq, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/faq.fe399d1e.svg";
export { ForwardRef as ReactComponent };